

export default function Notfound (){
    return(
        <>
        <div>this is the 404 page </div>
        </>
    )
}